
export const kontakteStyles = {
    filterTableKontakteView: {
        box: {
            backgroundColor: 'white'
        }
    },
    tableKontakteView: {
        box: {
            minHeight: 600,
            height: "100%",
            overflow: 'auto',
            width: "100%"
        },
        paper: {
            padding: 2,
            paddingBottom: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
        },
        headerBoxWrapper: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
        }
    },
    transcriptBox:{
        backgroundColor: '#f5f5f5',
        padding: 2,
        borderRadius: 1,
        maxHeight: 300,
        overflow: 'auto'
    },
    transcriptTabBox:{
        width: "100%"
    },
    transcriptBody:{
        whiteSpace: 'pre-wrap'
    },
    descriptionErrorBody:{
      fontWeight: 600
    },
    errorListItemStyle:{
        marginTop: 4
    }
}

